const DEFAULT_FLUSH_INTERVAL_MS = 500;
/**
 * Batches high-frequency payloads and flushes them at a controlled interval.
 * For each key, only the latest payload is retained, so rapid updates to the
 * same entity coalesce into a single cache write per flush cycle.
 *
 * The timer starts lazily on the first push and stops after flushing,
 * restarting only when new payloads arrive.
 */
export class UpdateBuffer {
    constructor(keyFn, flushFn, options = {}) {
        this.keyFn = keyFn;
        this.flushFn = flushFn;
        this.options = options;
        this.buffer = new Map();
        this.timer = null;
    }
    push(payload) {
        const key = this.keyFn(payload);
        const existing = this.buffer.get(key);
        this.buffer.set(key, existing && this.options.merge ? this.options.merge(existing, payload) : payload);
        if (!this.timer) {
            this.timer = setTimeout(() => {
                this.timer = null;
                this.flush();
            }, this.options.intervalMs ?? DEFAULT_FLUSH_INTERVAL_MS);
        }
    }
    flush() {
        if (this.buffer.size === 0)
            return;
        const snapshot = new Map(this.buffer);
        this.buffer.clear();
        this.flushFn(snapshot);
    }
    dispose() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.buffer.clear();
    }
}
